import { FormContainer } from '@strata/react-form-container';
import { Spinner } from '@strata/react-loading-animation';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import { postClearTask } from 'api/oopsAPI';
import { handleError } from 'services/Error';
import { useGetSupplierListQuery } from 'store/api/referenceApi';

const ValidationSchema = Yup.object({
    supplier_npi: Yup.string().required(validationStrings.requiredField.errorMessage),
    task_status: Yup.string().required(validationStrings.requiredField.errorMessage),
});

export const ClearWorklistTasks = () => {
    const [adminLog, setAdminLog] = useState<object>();

    const { data: supplierList, isFetching: supplierListFetching } = useGetSupplierListQuery();

    return (
        <Formik
            initialValues={{ task_status: 'completed' } as Yup.InferType<typeof ValidationSchema>}
            validationSchema={ValidationSchema}
            onSubmit={async (values) => {
                try {
                    const response = await postClearTask(values);
                    SuccessToast({ message: 'Worklist Tasks Cleared.' });
                    setAdminLog(response);
                } catch (err) {
                    handleError('Error clearing worklist tasks.', err as Error);
                }
            }}
        >
            {(formik) => (
                <FormContainer
                    formTitle="Clear Worklist Tasks"
                    primaryButtonLabel="Execute"
                    onFormSubmit={formik.handleSubmit}
                    isSubmitting={formik.isSubmitting || !(formik.dirty && formik.isValid)}
                    onCancelClick={formik.resetForm}
                    formLeftContent={
                        <>
                            <RadioButtonGroupFormik
                                name="task_status"
                                label="Task Status"
                                options={[
                                    { value: 'completed', text: 'Completed' },
                                    { value: 'all', text: 'All' },
                                ]}
                                inline
                            />
                            <SuggestSingleSelectFormik
                                id="supplier_npi"
                                label="Supplier NPI"
                                required
                                isLoading={supplierListFetching}
                                values={supplierList}
                                selectedItem={supplierList?.find(
                                    ({ npi }) => npi === formik.values.supplier_npi,
                                )}
                                onChange={(newValue) => {
                                    void formik.setFieldValue('supplier_npi', newValue?.npi);
                                }}
                            />
                        </>
                    }
                    formRightContent={
                        <>
                            <div>Task Status:</div>
                            {formik.isSubmitting ? (
                                <Spinner intent={Spinner.Intent.NONE} />
                            ) : (
                                <pre>{adminLog && JSON.stringify(adminLog, null, 2)}</pre>
                            )}
                        </>
                    }
                />
            )}
        </Formik>
    );
};
